<mat-form-field class="mdc-textarea-fix">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="selectedItems" multiple [compareWith]="compareObjects" okCustomDropDownArrowDirective>
    <mat-select-trigger>
      {{ getFirstItemName() }}
      @if ((selectedItems.value?.length || 0) > 1) {
        <span class="example-additional-selection">
          (+{{ (selectedItems.value?.length || 0) - 1 }} {{ selectedItems.value?.length === 2 ? 'mere' : 'flere' }})
        </span>
      }
    </mat-select-trigger>
    @for (item of enumDisplayItems(); track item.value) {
      <mat-option [value]="item.value">
        @if (template(); as tmpl) {
          <ng-container *ngTemplateOutlet="tmpl; context: { $implicit: item.value, displayText: item.displayText }"></ng-container>
        } @else {
          {{ item.displayText }}
        }
      </mat-option>
    }
  </mat-select>

  @if (initialValue() && (selectedItems.value?.length || 0) > 0) {
    <button
      matSuffix
      class="clear-input-field-button"
      type="button"
      (click)="clearInput(); $event.stopPropagation()"
      aria-label="Ryd indhold i feltet">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
    </button>
  }

  <mat-icon matSuffix></mat-icon>
</mat-form-field>
